import { CommandType } from "../../../../common/services/cqs/CommandType";
import { SkogsvardTradslagBaseCommand } from "./SkogsvardTradslagBaseCommand";

export class DeleteSkogsvardTradslagCommand extends SkogsvardTradslagBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteSkogsvardTradslagCommand";

    constructor(atgardGuid: string, guid: string) {
        super(atgardGuid, guid, DeleteSkogsvardTradslagCommand.$type, CommandType.Delete);
    }
}
